/**
 * Created by pc on 2018/12/26.
 */

import { get } from '@/agent/http/index';
import Page from '@/global/util/Page';
import { BASE_URL } from '@/global/util/constants'
import qs from 'qs'
const ADVERTISER_QUATYPE_MENU = 'ADVERTISER_QUATYPE_MENU'; // 资质类型下拉菜单
const ADVERTISER_INDUSTRY_MENU = 'ADVERTISER_INDUSTRY_MENU'; // 行业类型下拉菜单
const ADVERTISER_CIYTALL_MENU = 'ADVERTISER_CIYTALL_MENU'; // 省市区下拉菜单
const ADVERTISER_AD_TYPE_MENU = 'ADVERTISER_AD_TYPE_MENU'; // 广告主筛选类型
const ADVERTISER_TABLE_DATA = 'ADVERTISER_TABLE_DATA'; // 广告主列表
const state = {
  advertiser: {
    quaTypeMenu: [],
    curQuaType: '',
    industryMenu: [],
    cityArr: [{ name: {} }],
    adTypeMenu: [],
    curAdType: '',
    page: new Page(),
    downUrl: ''
  }
};

const getters = {
  advertiser: state => state.advertiser
};

const actions = {
  getQualificationType ({ state, commit }) {
    get('/interface/etcd/item/' + 'qua_type').then(data => {
      if (data.code === 1) {
        commit(ADVERTISER_QUATYPE_MENU, data.data);
      }
    });
  },
  getIndustryType ({ state, commit }) {
    get('/interface/etcd/item/' + 'industry').then(data => {
      if (data.code === 1) {
        commit(ADVERTISER_INDUSTRY_MENU, data.data);
      }
    });
  },
  async getCityAll ({ state, commit }) {
    await get('/interface/etcd/item/' + 'china-area').then(data => {
      if (data.code === 1) {
        commit(ADVERTISER_CIYTALL_MENU, data.data);
      }
    });
  },
  async getAdType ({ state, commit }) {
    await get('/agency/advertiser/selectlist').then(data => {
      if (data.code === 1) {
        commit(ADVERTISER_AD_TYPE_MENU, data.data);
      }
    });
  },
  async adverNameIsRepeat ({ state, commit }, { data }) {
    let response = await get('/agency/advertiser/is-repeated/' + data)
    return response
  },
  async nameIsRepeat ({ state, commit }, { data }) {
    let response = await get('/agency/advertiser/name-is-repeated/' + data)
    return response
  },
  getAdvertiserTable (
    { commit, state },
    { pageSize = state.advertiser.page.pageSize, currentPage = state.advertiser.page.currentPage, key, search } = {}
  ) {
    let params = {};
    params.page = currentPage;
    params.per_page = pageSize;
    params[key] = search;
    state.advertiser.page.clearData();
    get('/agency/advertiser', params).then(res => {
      if (res.code === 1) {
        params.is_export = 1
        let downUrl = BASE_URL + '/agency/advertiser?' + qs.stringify(params)
        commit(ADVERTISER_TABLE_DATA, { data: res.data, downUrl });
      }
    });
  }
};

const mutations = {
  [ADVERTISER_QUATYPE_MENU] (state, data) {
    state.advertiser.quaTypeMenu = data;
  },
  [ADVERTISER_INDUSTRY_MENU] (state, data) {
    state.advertiser.industryMenu = data;
  },
  [ADVERTISER_CIYTALL_MENU] (state, data) {
    state.advertiser.cityArr = data;
  },
  [ADVERTISER_AD_TYPE_MENU] (state, data) {
    state.advertiser.adTypeMenu = data;
    state.advertiser.curAdType = data[0].value;
  },
  [ADVERTISER_TABLE_DATA] (state, { data, downUrl }) {
    state.advertiser.downUrl = downUrl
    state.advertiser.page.setPageData(
      {
        header: data.header,
        data: data.data,
        total: data.count
      },
      false
    );
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
